export const routes = {
    dashboard: '/',
    xeppt_cards: '/xeppt-cards',
    xeppt_card: '/xeppt-cards/:id',
    order_xeppt_card: '/xeppt-cards/order-card',
    transactions: '/transactions',
    transaction_details: '/transactions/:id',
    signin: '/sign-in',
    signup: '/sign-up',
    hidden_signup: '/hidden/sign-up',
    hidden_signin: '/hidden/sign-in',
    forgot_password: '/forgot-password',
    hidden_forgot_password: '/hidden/forgot-password',
    settings_profile: '/settings/profile',
    settings_security: '/settings/security',
    settings_mfa: '/settings/mfa',
    limits: '/settings/limits',
    settings_api_keys: '/settings/api_keys',
    settings_notifications: '/settings/notifications',
    settings: '/settings',
    link_card_bank: '/link-card-or-bank',
    help_center: '/help-center',
    privacy_policy: '/privacy-policy',
    terms_of_service: '/terms-of-service',
    statements: '/statements',
    send_and_request: '/send-and-request',
    send_and_request_send: '/send-and-request/send',
    send_and_request_request: '/send-and-request/request',
    send_and_request_schedule: '/send-and-request/schedule',
    send_and_request_contacts: '/send-and-request/contacts',
    send_and_request_autodeposit: '/send-and-request/autodeposit',
    send_and_request_invite: '/send-and-request/invite',
    pay_bills: '/pay-bills',
    pay_bills_pay: '/pay-bills/pay-bills',
    pay_bills_payees: '/pay-bills/manage-payees',
    pay_bills_schedule: '/pay-bills/schedule-payments',
    manage_accounts: '/manage-accounts',
    not_found: '/not-found',
    cashback_history: '/cashback-history',
    extension_install: '/cash-back/installation',
    extension_uninstall: '/cash-back/uninstallation',
    my_loyalty_points: '/my-loyalty-points',
    gift_cards: '/gift-cards',
    gift_cards_create: '/gift-cards/create'
};
